import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CourseList from './course_list';
import CourseDetail from './course_detail';

class Course extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <CourseList/>;
    }else{
      if(params.id===undefined){
        view = <CourseDetail/>;
      }else{
        view = <CourseDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Course.contextTypes = {
  router: PropTypes.object
};

export default Course;
